import { useAddressSliceActions } from 'feature/addresses/hooks/useAddressSliceActions'
import { useAddressState } from 'feature/addresses/hooks/useAddressState'
import { CompanyDetailsFormValues } from 'feature/company/types/CompanyRegistrationForm'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { AddressSelectInput } from 'widget/AddressSelectInput'
import styles from '../CompanyRegistration.module.scss'
import { FIAS_LEVEL } from 'constants/const'

/**
 * Выделенный компонент для фактического адреса.
 * Изолирует подписку на company-слайс, чтобы ввод в это поле
 * не вызывал перерендер родителя (и карты).
 */
export function ActualAddressInput({
  setViewMode: _setViewMode,
}: {
  setViewMode: (str: string) => void
}) {
  const { isValid: isCompanyAddressValid, inputSuggest: companyInputSuggest } =
    useAddressState('company')
  const companyActions = useAddressSliceActions('company')
  const { setValue, getValues } = useFormContext<CompanyDetailsFormValues>()

  // Инициализация: загрузить сохранённый факт. адрес из формы в Redux
  useEffect(() => {
    const address = getValues('actualAddress')
    if (address?.address && address?.fiasId) {
      companyActions.setInputAddress(address.address)
      companyActions.setInputAddressSuggest({
        ...address,
        fiasLevel: address.fiasLevel ?? FIAS_LEVEL.toString(),
      })
      companyActions.setIsValidAddress(true)
    } else {
      companyActions.clearAddress()
    }
  }, [])

  // Синхронизация факт. адреса из Redux → react-hook-form
  useEffect(() => {
    if (companyInputSuggest && isCompanyAddressValid) {
      setValue('actualAddress', companyInputSuggest, { shouldValidate: true })
    }
  }, [companyInputSuggest, isCompanyAddressValid])

  return (
    <AddressSelectInput
      className={styles.companyRegistration__addressInput}
      name='actualAddress'
      addressKey='company'
      inputProps={{ 'data-testid': 'company-reg-actual-address' }}
    />
  )
}
